import { usePortfolio } from '../context/PortfolioContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaPen, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';

const Blog = () => {
  const { portfolioData, loading } = usePortfolio();
  const blogsData = portfolioData?.blog || [];

  if (loading) {
    return (
      <section id="blog" className="py-20 bg-gray-900">
        <div className="container">
          <div className="animate-pulse">
            <div className="h-10 bg-gray-700 w-1/3 mb-12 rounded"></div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[1, 2, 3].map((index) => (
                <div key={index} className="bg-gray-800 rounded-lg overflow-hidden">
                  <div className="h-48 bg-gray-700"></div>
                  <div className="p-6 space-y-3">
                    <div className="h-5 bg-gray-700 w-3/4 rounded"></div>
                    <div className="h-4 bg-gray-700 w-full rounded"></div>
                    <div className="h-4 bg-gray-700 w-5/6 rounded"></div>
                    <div className="flex gap-2">
                      <div className="h-4 bg-gray-700 w-16 rounded-full"></div>
                      <div className="h-4 bg-gray-700 w-16 rounded-full"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  const visibleBlogs = blogsData.filter(blog => blog.visible);

  return (
    <section id="blog" className="py-18 bg-gray-900">
      <div className="container">
        <motion.div 
          className="flex items-center gap-3 mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <FaPen className="text-primary text-2xl" />
          <h2 className="section-title text-white">Latest Blog Posts</h2>
        </motion.div>

        {visibleBlogs.length === 0 ? (
          <div className="text-gray-400 text-center py-12">No blog posts available yet.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {visibleBlogs.map((blog, index) => (
              <motion.article 
                key={blog.id || blog.slug}
                className="bg-gray-800/50 rounded-lg overflow-hidden border border-gray-700 hover:border-primary/30 transition-all hover:-translate-y-1 hover:shadow-lg hover:shadow-primary/5 flex flex-col"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="h-48 overflow-hidden relative">
                  <img 
                    src={blog.coverImage} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex justify-between items-center text-xs text-gray-400 mb-3">
                    <div className="flex items-center gap-1">
                      <FaCalendarAlt />
                      <span>{blog.publishedAt}</span>
                    </div>
                    <span>{blog.readTime}</span>
                  </div>
                  
                  <h3 className="text-xl font-medium text-white mb-3">
                    <Link 
                      to={`/blog/${blog.slug}`}
                      className="hover:text-primary transition-colors"
                    >
                      {blog.title}
                    </Link>
                  </h3>
                  
                  <p className="text-gray-300 mb-4 flex-1">
                    {blog.excerpt}
                  </p>
                  
                  <div className="flex flex-wrap gap-2 mb-4">
                    {blog.tags && blog.tags.map((tag, tagIndex) => (
                      <span 
                        key={tagIndex} 
                        className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  
                  <Link 
                    to={`/blog/${blog.slug}`}
                    className="inline-flex items-center gap-2 text-primary hover:underline mt-auto"
                  >
                    Read Full Article <FaArrowRight size={12} />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        )}
        <div className="mt-12 text-center">
          <Link 
            to="/blog"
            className="inline-flex items-center gap-2 bg-primary/10 hover:bg-primary/20 text-primary px-6 py-3 rounded-lg transition-colors"
          >
            View All Posts <FaArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog; 